<mat-toolbar color="accent">
  <mat-toolbar-row>
    <!--Versión anterior-->
    <!-- <span *ngIf="(report$ | async) as report; else loading" style="font-size:10pt">
      {{ report.name }}:
      <span *ngIf="(student$ | async) as student; else loading" style="font-size:10pt">
        {{ student.fatherName }} {{ student.motherName }}, {{ student.name }}
      </span>
    </span> -->
    @if(report != null) {
       <span style="font-size:10pt">
          {{ report.name }}:

          @if (student != null) {
          <span style="font-size:10pt">
            {{ student.fatherName }} {{ student.motherName }}, {{ student.name }}
          </span>
          }
          @else {
            <div #loading></div>
          }
       </span>
    }
    @else {
      <div #loading></div>
    }

    <!-- <span style="font-size:10pt">
      {{ report.name }}:
      <span *ngIf="student != null; else loading" style="font-size:10pt">
        {{ student.fatherName }} {{ student.motherName }}, {{ student.name }}
      </span>
    </span> -->
    <span class="example-spacer"></span>
    <button mat-raised-button color="primary" (click)="downloadFile()">Descargar libreta en Word</button>
  </mat-toolbar-row>
</mat-toolbar>

<mat-card>
  <mat-card-content>
    <h2>Áreas</h2>
    @if (listOfAreas != null) {

      @for(area of listOfAreas; track area.id) {
        <div>
          <strong>{{ area.data.name }}</strong>
          <app-score-item [areaId]="area.id"></app-score-item>
        </div>

        <!-- <app-score-item [areaId]="area.id"></app-score-item> -->
      }
    }
    <!-- <div *ngFor="let area of listOfAreas$ | async">
      <strong>{{ area.name }}</strong>
      <app-score-item [areaId]="area.id"></app-score-item>
    </div> -->
    <!--Comments-->
    <strong>Observaciones</strong>
    <br>

    <textarea style="width: 400px;" cols="10" rows="10"  name="text" (blur)="saveComment($event)">{{ comment.text }}</textarea>


  </mat-card-content>
</mat-card>

<ng-template #loading>
  Cargando...
</ng-template>
